import { render, staticRenderFns } from "./CredentialSample.vue?vue&type=template&id=9a520020&scoped=true&"
import script from "./CredentialSample.vue?vue&type=script&lang=js&"
export * from "./CredentialSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a520020",
  null
  
)

export default component.exports